// extracted by mini-css-extract-plugin
export default {"chip":"feature-chip_chip__NOnii","icon":"feature-chip_icon__LqMVi","info":"feature-chip_info__-6xyO","label":"feature-chip_label__gFkQr","value":"feature-chip_value__yM0RQ"};